import { PageProps, graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';
import { Stack } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { CMS_THEME } from 'src/common/enums';
import { CmsButtonLink } from 'src/components/button/CmsButton';
import Layout from '../components/Layout';
import Seo from '../components/Seo';

const linksList = [
  {
    key: 1,
    link: '/',
    label: 'Homepage',
  },
  {
    key: 2,
    link: '/dogs/dog-food',
    label: 'Dog Food',
  },
  {
    key: 3,
    link: '/cats/cat-food',
    label: 'Cat Food',
  },
];

const NotFoundPage: React.FC<PageProps> = () => {
  return (
    <Layout language="en">
      <Seo
        title="Error 404: We’re soooo sorry! | Purina"
        meta={[{ name: 'description', content: "We didn't mean to lose your page." }]}
      />
      <Container className="p-5 text-center d-grid gap-5">
        <StaticImage
          src="../assets/media/images/Purina-404.jpeg"
          alt=""
          height={600}
          width={1640}
        />
        <Stack className="gap-4">
          <h1 className="fw-normal pds-text-display-sm">We’re soooo sorry!</h1>
          <h2 className="fw-light lh-base text-dark text-center pds-text-title-lg">
            We didn&#39;t mean to lose your page. <br /> Try the following pages:
          </h2>
        </Stack>
        <Stack
          direction="vertical"
          gap={3}
          className="justify-content-center align-items-center flex-sm-row"
        >
          {linksList.map(({ key, link, label }) => (
            <CmsButtonLink
              key={key}
              variant="btn-outline"
              cmsTheme={CMS_THEME.LIGHT}
              aria-label={label}
              to={link}
            >
              {label}
            </CmsButtonLink>
          ))}
        </Stack>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  {
    locales: allLocale(filter: { language: { eq: "en" } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default NotFoundPage;
